import { initSentry } from "@andre1502/react-utilities/sentry";
import * as Sentry from "@sentry/react";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const brand = process.env.REACT_APP_PROD_NAME_DEV;

export const startSentry = () => {
  const { name, version } = require("../../package.json");
  const env = process.env.REACT_APP_ENV ?? "dev";
  const dsn = process.env.REACT_APP_SENTRY_DSN ?? "";
  const mainUrl = process.env.REACT_APP_API_MAIN_URL ?? "";
  const utilUrl = process.env.REACT_APP_API_UTIL_URL ?? "";
  const userUrl = process.env.REACT_APP_API_USER_URL ?? "";

  if (!dsn) {
    console.error("Missing sentry dsn value in .env.");
    return;
  }

  if (!mainUrl) {
    console.error("Missing API main url value in .env.");
    return;
  }

  if (!utilUrl) {
    console.error("Missing API util url value in .env.");
    return;
  }

  if (!userUrl) {
    console.error("Missing API user url value in .env.");
    return;
  }

  const failedRequestTargets = ["http://localhost", mainUrl, utilUrl, userUrl];

  initSentry({
    env: env,
    dsn: dsn,
    debug: env !== "production",
    release: `${name}-${brand}@${version}`,
    requiredEnvForSendToSentry: ["production"],
    httpClientIntegrationOptions: {
      failedRequestStatusCodes: [400, [402, 499], [500, 599]],
      failedRequestTargets: failedRequestTargets,
    },
    captureConsoleIntegrationOptions: {
      levels: ["error"],
    },
    options: {
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
    },
  });

  Sentry.setTag("platform", brand);
};
